//生产与测试环境路由配置
export const rootUrl=window.location.origin
